export default "__VITE_ASSET__0uRNr$Jw__"